<template>
  <v-container fluid class="payment-settings-page pa-2 my-3 sm:pa-4 sm:my-6">
    <v-card elevation="0" class="payment-settings-card pa-3 sm:pa-6">
      <header class="mb-6 flex items-center gap-3">
        <span class="flex h-11 w-11 items-center justify-center rounded-xl bg-slate-100 text-slate-700">
          <v-icon size="22">mdi-cash-cog</v-icon>
        </span>
        <div>
          <h1 class="text-xl font-bold text-slate-900">تنظیمات تسویه و کارمزد</h1>
          <p class="mt-1 text-sm text-slate-500">مقادیر پیش‌فرض تسویه ریالی و تتری را مدیریت کنید.</p>
        </div>
      </header>

      <v-form ref="form" v-model="valid" @submit.prevent="saveSettings">
        <!-- بخش تومان -->
        <v-expansion-panels v-model="rialPanel" class="payment-settings-panels mb-4">
          <v-expansion-panel rounded="xl">
            <v-expansion-panel-header>
              <v-icon class="mr-2">mdi-cash</v-icon>
              تنظیمات تومان (IRR)
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="pa-2 sm:pa-4">
                <v-col cols="12" md="6">
                  <v-select v-model="getPaymentSetting.rialiDefaultSettlementType" :items="settlementTypes" label="نوع تسویه پیش‌فرض"
                    :rules="[v => !!v || 'الزامی است']" />
                </v-col>

                <!-- <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="getPaymentSetting.rialiTransactionFeePercent"
                    label="درصد کارمزد تراکنش (%)"
                    type="number"
                    suffix="%"
                    :rules="percentRules"
                  />
                </v-col> -->

                <v-col cols="12" md="6">
                  <v-text-field v-model.number="getPaymentSetting.rialiTransactionFeeCap" label="سقف کارمزد تراکنش (تومان)"
                    type="number" prefix="تومان" />
                </v-col>

                <!-- <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="getPaymentSetting.rialiInstantSettlementFee"
                    label="کارمزد تسویه فوری"
                    type="number"
                    suffix="%"
                    :rules="percentRules"
                  />
                </v-col> -->

                <v-col cols="12" md="6">
                  <v-text-field v-model="getPaymentSetting.rialiCycleSettlementTime" label="زمان تسویه دوره‌ای" type="text"
                    placeholder="مثال: 11:15" :rules="timeRules" />
                </v-col>

                <!-- کارمزدهای دوره‌ای و فوری -->
                <v-col cols="12">
                  <v-divider class="my-4" />
                  <h3 class="text-subtitle-1 font-weight-medium mb-3">کارمزدهای دوره‌ای و فوری</h3>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field v-model.number="getPaymentSetting.rialiCycleFixedFee" label="کارمزد ثابت دوره‌ای (تومان)"
                    type="number" prefix="تومان" />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model.number="getPaymentSetting.rialiCyclePercentageFee" label="درصد کارمزد دوره‌ای" type="number"
                    suffix="%" :rules="percentRules" />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field v-model.number="getPaymentSetting.rialiInstantFixedFee" label="کارمزد ثابت فوری (تومان)"
                    type="number" prefix="تومان" />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model.number="getPaymentSetting.rialiInstantPercentageFee" label="درصد کارمزد فوری" type="number"
                    suffix="%" :rules="percentRules" />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field v-model.number="getPaymentSetting.rialiInstantFeeCap" label="سقف کارمزد فوری (تومان)" type="number"
                    prefix="تومان" />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- بخش تتر -->
        <v-expansion-panels v-model="usdtPanel" class="payment-settings-panels mb-4">
          <v-expansion-panel rounded="xl">
            <v-expansion-panel-header>
              <v-icon class="mr-2">mdi-currency-usd</v-icon>
              تنظیمات تتر (USDT)
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="pa-2 sm:pa-4">
                <v-col cols="12" md="6">
                  <v-select v-model="getPaymentSetting.usdtDefaultSettlementType" :items="settlementTypes" label="نوع تسویه پیش‌فرض"
                    :rules="[v => !!v || 'الزامی است']" />
                </v-col>

                <!-- <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="getPaymentSetting.usdtCycleSettlementFee"
                    label="کارمزد تسویه دوره‌ای"
                    type="number"
                    suffix="%"
                    :rules="percentRules"
                  />
                </v-col> -->

                <!-- <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="getPaymentSetting.usdtInstantSettlementFee"
                    label="کارمزد تسویه فوری"
                    type="number"
                    suffix="%"
                    :rules="percentRules"
                  />
                </v-col> -->

                <v-col cols="12" md="6">
                  <v-text-field v-model.number="getPaymentSetting.usdtMinimumSettlement" label="حداقل مبلغ تسویه (USDT)"
                    type="number" prefix="USDT" :rules="[v => v >= 0 || 'باید مثبت باشد']" />
                </v-col>

                <!-- کارمزدهای دوره‌ای و فوری تتر -->
                <v-col cols="12">
                  <v-divider class="my-4" />
                  <h3 class="text-subtitle-1 font-weight-medium mb-3">کارمزدهای دوره‌ای و فوری</h3>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field v-model.number="getPaymentSetting.usdtCycleFixedFee" label="کارمزد ثابت دوره‌ای (USDT)" type="number"
                    prefix="USDT" />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model.number="getPaymentSetting.usdtCyclePercentageFee" label="درصد کارمزد دوره‌ای" type="number"
                    suffix="%" :rules="percentRules" />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field v-model.number="getPaymentSetting.usdtInstantFixedFee" label="کارمزد ثابت فوری (USDT)" type="number"
                    prefix="USDT" />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model.number="getPaymentSetting.usdtInstantPercentageFee" label="درصد کارمزد فوری" type="number"
                    suffix="%" :rules="percentRules" />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- پرداخت‌کننده پیش‌فرض -->
        <!-- <v-select v-model="getPaymentSetting.defaultFeePayerType" :items="feePayerTypes" label="پرداخت‌کننده پیش‌فرض کارمزد"
          class="mb-4" :rules="[v => !!v || 'الزامی است']" /> -->

        <!-- دکمه‌ها -->
        <v-card-actions class="justify-end border-t border-slate-100 pt-4">
          <!-- <v-btn color="grey lighten-2" @click="resetForm">
            بازنشانی
          </v-btn> -->
          <v-btn color="primary" type="submit" :disabled="!valid" :loading="loading">
            ذخیره تغییرات
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import store from '@/store';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PaymentSettingsForm',

  data() {
    return {
      valid: true,
      loading: false,

      rialPanel: [0],  // باز بودن پنل اول
      usdtPanel: [0],

      settlementTypes: ['INSTANT', 'CYCLE'],
      feePayerTypes: ['BUSINESS', 'CUSTOMER'],

      percentRules: [
        v => v >= 0 || 'باید مثبت باشد',
        v => v <= 100 || 'حداکثر 100%'
      ],
      timeRules: [
        v => !!v || 'الزامی است',
        v => /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(v) || 'فرمت زمان: HH:MM'
      ],

      // مقادیر پیش‌فرض دقیقاً مطابق درخواست شما
      form: {}
    }
  },

  computed: {
    getPaymentSetting() {
      const data = store.getters["panel/getPaymentSetting"];
      // this.form = data;
      return data;
    },
  },

  methods: {
    resetForm() {
      // بازگردانی به مقادیر اولیه
      Object.assign(this.$data.form, this.$options.data().form)
      this.$refs.getPaymentSetting.resetValidation()
    },

    async saveSettings() {
      if (!this.valid) return

      this.loading = true

      try {
        store.dispatch("panel/updatePaymentSettingRequest", this.getPaymentSetting);
      } catch (err) {
        this.$toast.error('خطا در ذخیره!')
      } finally {
        this.loading = false
      }
    }
  },

  mounted() {
    store.dispatch("panel/getPaymentSettingRequest");
    this.form = this.getPaymentSetting;
  }
})
</script>

<style scoped>
.payment-settings-page {
  max-width: 1200px;
  margin-inline: auto;
}

.payment-settings-card {
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  box-shadow: 0 8px 24px rgba(15, 23, 42, .04);
}

.payment-settings-panels :deep(.v-expansion-panel) {
  border: 1px solid #e2e8f0;
  box-shadow: none;
}

.payment-settings-panels :deep(.v-expansion-panel-title) {
  min-height: 60px;
  font-weight: 700;
}

.payment-settings-card :deep(.v-input) {
  min-width: 0;
}
</style>